<div style="display: flex; gap: 2%" >
  <app-common-button
    label="Upload File"
    title="Upload File"
    icon="fas fa-upload"
   
    [buttonId]="1111"
    
    (clicked)="fileInput.click()"
  >
  </app-common-button>

        <app-common-button
        title="Refresh"
        icon="fas fa-sync-alt"
        [buttonId]="1111"
        [variant]="'cancel'"
        (clicked)="onAttachmentRefresh()"
      >
      </app-common-button>
  
  <span class="example-spacer"></span>
  
  <!-- <app-common-button
    label="Complete"
    title="Complete"
    [buttonId]="1111"
    width="110px"
    [critical]="true"
    (clicked)="onComplete()"
    style="margin-left: 6px; margin-right: 6px"
  >
  </app-common-button> -->
</div>

<div style="width: 100%; margin-bottom: 5%">
  <!-- HEADER -->
  <div class="attachment-header">
    <input
      #fileInput
      type="file"
      hidden
      multiple
      accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,image/*"
      (change)="onFileSelected($event)"
    />
  </div>

  <!-- EMPTY STATE -->
  <!-- <div *ngIf="attachments.length === 0" class="empty-state">
    No attachments uploaded.
  </div> -->

  <!-- ATTACHMENTS TABLE -->
  <!-- <table
    mat-table
    [dataSource]="attachments"
    class="mat-elevation-z1 attachments-table"
    *ngIf="attachments.length > 0"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>File Name</th>
      <td mat-cell *matCellDef="let file">{{ file.name }}</td>
    </ng-container>

    <ng-container matColumnDef="size">
      <th mat-header-cell *matHeaderCellDef>Size</th>
      <td mat-cell *matCellDef="let file">{{ file.size | number }} bytes</td>
    </ng-container>

    <ng-container matColumnDef="uploaded">
      <th mat-header-cell *matHeaderCellDef>Uploaded</th>
      <td mat-cell *matCellDef="let file">
        {{ file.uploaded | date: "MMM dd, yyyy" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let file">
        <button mat-icon-button color="warn" (click)="removeAttachment(file)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="attachmentColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: attachmentColumns"></tr>
  </table> -->
        <ag-grid-angular
        
        class="ag-theme-balham"
        style="width: 100%; height: 250px;"
        [rowData]="attachments"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [pagination]="true"
        [paginationPageSize]="5"
        [components]="components"
      [rowHeight]="35"
      [headerHeight]="35"
      [floatingFiltersHeight]="45"
      [enableBrowserTooltips]="true">
      </ag-grid-angular>
      


      <!-- ================= LINKS SECTION ================= -->

      <div class="add-link-row" style="margin-top: 2rem;">
         <h4>Links</h4>

        <mat-form-field appearance="outline" class="full">
          <mat-label>Add Link</mat-label>
          <input matInput  #linkCtrl="ngModel" name="link" [(ngModel)]="newLink" placeholder="https://...">
            <mat-error *ngIf="linkCtrl.errors?.['required']">
            Link is required
          </mat-error>
        </mat-form-field>
        <div style="display: flex; gap: 2%">
        <app-common-button
          label="Add Link"
          icon="fas fa-link"
          [buttonId]="1111"
          (clicked)="addLink(linkCtrl)">
        </app-common-button>

        <app-common-button
        title="Refresh"
        icon="fas fa-sync-alt"
        [buttonId]="1111"
        [variant]="'cancel'"
       
        (clicked)="onLinksRefresh()"
      >
      </app-common-button>
      </div>
      </div>

      <div *ngIf="links.length === 0" class="empty-state">
        No links added.
      </div>

      <div *ngIf="links.length > 0" class="links-section">
       

        <!-- <div *ngFor="let link of links" class="link-row">
          <a [href]="link.url" target="_blank">{{ link.url }}</a>

          <button
            mat-icon-button
            color="warn"
            (click)="removeLink(link)"
            >
            <mat-icon>delete</mat-icon>
          </button>
        </div> -->

          <ag-grid-angular
          
          class="ag-theme-balham"
          style="width: 100%; height: 200px; margin-top: 1rem;"
          [rowData]="links"
          [columnDefs]="linkColumnDefs"
          [defaultColDef]="defaultColDef"
          [pagination]="true"
           [paginationPageSize]="5"
           [rowHeight]="35"
           [components]="components"
      [headerHeight]="35"
      [floatingFiltersHeight]="45"
      [enableBrowserTooltips]="true">
        </ag-grid-angular>
      </div>

    


</div>